<template>
<div>
  <div v-for="(geo, index) in geodata" :key="index">
    <div class="footfall-uplift-details" v-if="geo && geo.admin1.toLowerCase() == currentstate">
      <div class="province-details col-xs-6">
        <div class="state-data" role="hideable-element">
          <ul class="row without-border with-margin">
            <div class="col-xs-6">
              <li class="without-padding">
                <h4 class="low-margin">
                  <img class="flag" :src="$chartSettings['image_path'] + 'flags/allstates_ca.png'" />
                  {{ get_state_name }}
                </h4>
              </li>
            </div>
          </ul>
          <ul class="row with-margin">
            <div class="col-xs-6">
              <li class="pois">Number of POIs<strong>{{ geo.places }}</strong></li>
              <li class="impressions">Number of impressions<strong>{{ nFormatter(geo.delivered_impression, 2) }}</strong></li>
              <li class="reached">Devices Reached<strong>{{ nFormatter(geo.reached_devices, 0) }}</strong></li>
            </div>
            <div class="col-xs-6">
              <li class="conversion">Visit Rate
                <info-tooltip text="Visit rate represents the number of converted devices out of the total number of exposed devices."/>
                <strong>{{ (geo.visit_rate * 100).toFixed(2) }}%</strong>
              </li>
              <li class="cost-per-visit" v-if="geo.cost_per_visit">Cost per incremental visit
                <info-tooltip text="Amount of budget spent to receive one incremental visit from the exposed group in regards to control group visits."/>
                <strong>${{ geo.cost_per_visit.toFixed(2) }}</strong>
              </li>
              <li class="impression-per-visit" v-if="geo.impression_sent_per_visit">Impressions per incremental visit
                <info-tooltip text="Amount of impressions delivered to receive one incremental visit from the exposed group in regards to control group visits."/>
                <strong>{{ nFormatter(geo.impression_sent_per_visit, 2) }}</strong>
            </li>
            </div>
          </ul>
        </div>
      </div>
      <div class="uplift-details col-xs-6 state-radial fade in" role="hideable-element">
        <h4 class="low-margin">Footfall Uplift
          <info-tooltip text="Percentage variation between users exposed to the campaign who visited the store and control group users who visited the store."/>
        </h4>
        <div class="radial uplift">
          <div class="footfall-uplift-container">
            <a>
              <div id="us-radial" class="cuebiq-radial uplift  not-selectable">
                <vue-circle
                        :progress="geo.uplift * 100"
                        :size="120"
                        :reverse="false"
                        line-cap="round"
                        :fill="{ color: $chartSettings['progress_circle']['fill'] }"
                        empty-fill="rgba(0, 0, 0, .1)"
                        :animation-start-value="0.0"
                        :start-angle="-1.57"
                        insert-mode="append"
                        :thickness="$chartSettings['progress_circle']['thickness']"
                        :show-percent="false">
                  </vue-circle>
              </div>
            </a>
            <div class="footfall-uplift-numeric-message">
              <div v-if="nFormatter(geo.uplift * 100, 0) == 0" >
                <h5 class="footfall-uplift-campaign-no-effect">The campaign had no effect</h5>
              </div>
              <div v-else>
                <div class="metric metric--numeric metric--numeric-no-margin metric--icon">
                  <div class="metric__icon-container metric__icon-container--numeric">
                    <i v-bind:class="[{'fa fa-2x fa-times' : geo.pvalue > 0.075},{'fa fa-2x fa-check' : geo.pvalue < 0.075}]"></i>
                  </div>
                  <div class="metric__content metric__content--numeric">
                    <h3 class="metric__title metric__title--numeric ">{{ nFormatter(geo.uplift * 100, 0) }}%</h3>
                    <p class="metric__subtitle">
                      <span>Uplift
                        <b v-if="geo.pvalue < 0.075">with</b>
                        <b v-if="geo.pvalue > 0.075">without</b>
                         Statistical<br>Evidence
                      </span>
                      <info-tooltip text="Statistical evidence states that the amount of visit lift is backed by reliable information."/>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="margin-t-10">
            <div class="col-xs-12">
              <div class="benchmark" v-if="geo.benchmark">
                <h5 class="benchmark__title">Quality of uplift vs. Benchmarks</h5>
                <span class="benchmark__label" v-bind:class="[{'benchmark__label--low' : geo.benchmark=='low'}, {'benchmark__label--active' : geo.benchmark=='low'}]">
                  <i class="fas fa-chevron-down fa-sm" v-if="geo.benchmark=='low'" /><br>
                  <span>low (&lt; {{ nFormatter(geo.min_threshold * 100, 0)}}%)</span>
                </span>

                <span class="benchmark__label" v-bind:class="[{'benchmark__label--medium' : geo.benchmark=='medium'}, {'benchmark__label--active' : geo.benchmark=='medium'}]">
                  <i class="fas fa-chevron-down fa-sm" v-if="geo.benchmark=='medium'" /><br>
                  <span>medium</span>
                </span>

                <span class="benchmark__label" v-bind:class="[{'benchmark__label--high' : geo.benchmark=='high'}, {'benchmark__label--active' : geo.benchmark=='high'}]">
                  <i class="fas fa-chevron-down fa-sm" v-if="geo.benchmark=='high'" /><br>
                  <span>high (&gt; {{ nFormatter(geo.max_threshold * 100, 0) }}%)</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  import Vue from 'vue';
  import VueChartJs from 'vue-chartjs';
  import VueCircle from 'vue2-circle-progress'
  import utils from '@/modules/utils';
  import InfoTooltip from '../widgets/InfoTooltip';

  export default {
    name: 'conversion-analysis-geo',
    props: ['geodata', 'currentstate'],
    components: {
      InfoTooltip,
      VueCircle
    },
    computed : {
        get_state_name : function() {
          return this.currentstate == "allstates" ? "ALLPROVINCES" : this.currentstate.toUpperCase();
        }
    },
    methods: {
      nFormatter: utils.format.nFormatter
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/widgets/ConversionAnalysisGeo.vue